import { Component, OnInit } from '@angular/core';
import CryptoJS from 'crypto-js';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

const passwordKey = '14accb2b-30de-4de8-8516-d343c214d530';
const localStorageKeys = {
  iv: 'sgzp_iv',
  salt: 'sgzp_salt',
  main: 'sgzp_email_password',
};

@Component({
  selector: 'app-collabo-portal-dxsales-login',
  templateUrl: './collabo-portal-dxsales-login.component.html',
  styleUrls: [
    './collabo-portal-dxsales-login.component.css',
    '../style/global.css',
  ],
})
export class CollaboPortalDxsalesLoginComponent
  extends BaseLoginComponent
  implements OnInit {
  async init(): Promise<void> { }

  saveEmailAddress() {
    // メール・パスワード保存処理. 改行区切りでメール・パスワードを一つの文字列にして、暗号化して保存する
    localStorage.setItem(
      localStorageKeys.main,
      this.getEncryptData([this.email, this.password].join('\n'), passwordKey)
    );
  }

  /**
   *  暗号化
   *  @param data 暗号化する値
   *  @param pass パス
   *  @returns 暗号化された値
   */
  getEncryptData(data: string, pass: string) {
    // ソルト
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    // 初期ベクトル
    var ivStr = CryptoJS.lib.WordArray.random(128 / 8).toString();
    var iv = CryptoJS.enc.Hex.parse(ivStr);
    // AESキーの生成
    const key = CryptoJS.PBKDF2(pass, salt.toString(), {
      keySize: 128 / 32,
      iterations: 50000,
      hasher: CryptoJS.algo.SHA256,
    });
    // AESキーで暗号化
    const encryptData = CryptoJS.AES.encrypt(data, key, {
      iv: iv,
    });
    this.setSalt(salt);
    this.setIv(ivStr);
    return encryptData.toString();
  }

  setSalt(salt: string) {
    localStorage.setItem(localStorageKeys.salt, salt);
  }
  getSalt() {
    return localStorage.getItem(localStorageKeys.salt);
  }
  getIv() {
    return localStorage.getItem(localStorageKeys.iv);
  }
  setIv(ivStr: string) {
    localStorage.setItem(localStorageKeys.iv, ivStr);
  }

  loadEmailFromStorage() {
    // 複合前の文字列を取得
    const saved = localStorage.getItem(localStorageKeys.main);

    // 保存されていれば、複合する
    if (saved) {
      // 複合したデータ
      const decryptedEmail = this.getDecryptData(saved, passwordKey) as string;
      // 改行区切りになっているので取り出す
      const decryptedSplitedString = decryptedEmail.split('\n');
      this.email = decryptedSplitedString[0];
      this.password = decryptedSplitedString[1];
      this.isSaveEmail = true;

      return true;
    }
    return false;
  }

  clearEmailAddress() {
    localStorage.removeItem(localStorageKeys.main);
    localStorage.removeItem(localStorageKeys.iv);
    localStorage.removeItem(localStorageKeys.salt);
  }
  /**
   *  複合化
   *  @param data 暗号化された値
   *  @param pass パス
   *  @returns 複合された値
   */
  getDecryptData(data: string, pass: string) {
    // AESキーの生成
    const key = CryptoJS.PBKDF2(pass, this.getSalt(), {
      keySize: 128 / 32,
      iterations: 50000,
      hasher: CryptoJS.algo.SHA256,
    });

    // AESキーで復号
    const decryptData = CryptoJS.AES.decrypt(data, key, {
      iv: CryptoJS.enc.Hex.parse(this.getIv()),
    });
    return decryptData.toString(CryptoJS.enc.Utf8);
  }
  async navigateCportal(page: string) {
    window.open(environment.baseUri + '/' + page + '?client_id=' + this.clientId);
  }
}
